import React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { usePaginationAction } from './use-pagination-action';
import { InfinitePagination } from './infinite-pagination.component';

export type InfinitePaginationProps = {
  currentPageLabel: string;
  nextPageLabel?: string;
  nextPageCursor?: string;
  previousPageLabel?: string;
  previousPageCursor?: string;
  reloadNodeIds: string[];
};

type InfinitePaginationNode = MasonryEngineNode<
  'infinitePagination',
  InfinitePaginationProps
>;

export type InfinitePaginationNodeRendererProps =
  MasonryEngineNodeRendererProps<InfinitePaginationNode>;

export function InfinitePaginationNodeRenderer({
  previousPageCursor,
  nextPageCursor,
  currentPageLabel,
  nextPageLabel,
  previousPageLabel,
  nodeId,
  reloadNodeIds,
  isReloading,
}: InfinitePaginationNodeRendererProps) {
  const nodeIds = [nodeId, ...reloadNodeIds];

  const onPreviousPage = usePaginationAction({
    from: previousPageCursor,
    nodeIds,
  });
  const onNextPage = usePaginationAction({
    from: nextPageCursor,
    nodeIds,
  });

  return (
    <InfinitePagination
      currentPageLabel={currentPageLabel}
      previousPageLabel={previousPageLabel}
      previousPageCursor={previousPageCursor}
      onPreviousPage={onPreviousPage}
      nextPageLabel={nextPageLabel}
      nextPageCursor={nextPageCursor}
      onNextPage={onNextPage}
      isLoading={isReloading}
    />
  );
}
